var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',_vm._b({attrs:{"name":"expand"},on:{"enter":_vm.enter,"afterEnter":_vm.afterEnter,"leave":_vm.leave}},'transition',_vm.$attrs,false),[(_vm.visible)?_c('div',{class:_vm.classes},[_c('div',{ref:"staticWidth"},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }